import React, { Component } from 'react';
import './App.css';
import Gallery from './components/Pages/Gallery/Gallery';
import Info from './components/Pages/Info/Info';
import Upload from './components/Pages/Upload/Upload';
import {Routes, Route } from 'react-router-dom';
import dataset from './assets/stk_db/stickfig.json';
import Menu from './components/Navigation/Menu/Menu';

class App extends Component{
  
  state = {
    stickfig: [
     ],
    FilterCategory: false,
    filterCategoryName: "All",
    FilterVersion: false,
    filterVersionName: "All",
    stickshown: "0005",
    FilterCreator: false,
    creatorName: "",
    filterName: "",
    showItems: 480
  }


  setStick = (data) => {
  this.setState({
      stickfig: data
  })

  }

  showInfoTile = (stickfigId) => {
    this.setState({
      stickshown: stickfigId,
      filterName: ""
    })
  }

  filterCategory = (category) => {
    if (category === "All"){
      this.setState({
        FilterCategory: false,
        filterCategoryName: category,
        filterName: "",
        showItems: 480
      })
    } else {
      this.setState({
        FilterCategory: true,
        filterCategoryName: category,
        filterName: "",
        showItems: 480
      })
    }
  }

  filterVersion = (version) => {

    if (version === "All"){
      this.setState({
        FilterVersion: false,
        filterVersionName: version,
        filterName: "",
        showItems: 480
      })
    } else {
      this.setState({
        FilterVersion: true,
        filterVersionName: version,
        filterName: "",
        showItems: 480
      })
    }
  }

  setCreator = (data) => {
    this.setState({
        creatorName: data,
        filterName: ""
    })
    
    }

  filterSearch= (data) => {
    this.setState({
      filterName: data
    })
    
    }

  handleShowMore(length) {
    console.log(length)
    this.setState({
      showItems: 
        this.state.showItems >= length ?
        this.state.showItems : this.state.showItems + 480
    })
  }

  componentDidMount() {
    const script = document.createElement("script");
    script.async = true;
    script.src = "//www.ezojs.com/ezoic/sa.min.js";
    script.onload = () => this.scriptLoaded();
    script.id = 'ezoic';

    //For head
    this.div.appendChild(script);
  }


  render() {

    if (this.state.stickfig.length === 0){
      this.setStick(dataset.stickfig)
    } 
  

    return (
      <div className="App" ref={el => (this.div = el)}>
        
        <Routes>
          <Route path="/" exact element={                  
            <div className="Base">
                        <div className="Menu">
                            <Menu 
                                filterCategory = {this.state.filterCategoryName} 
                                filterVersion= {this.state.filterVersionName} 
                                clickcat={(e) => this.filterCategory(e)}
                                clickVersion={(e) => this.filterVersion(e)}
                                filter={(e) => this.filterSearch(e)}
                                filterName = {this.state.filterName}/>
                                            
                        </div>
                        <div className="Gallery">
                            <Gallery click={this.showInfoTile} 
                              filterCategory = {this.state.filterCategory} 
                              filterVersion= {this.state.filterVersion}     
                              filterCategoryName = {this.state.filterCategoryName}
                              filterVersionName= {this.state.filterVersionName} 
                              stickfig= {this.state.stickfig} 
                              creator = {this.state.creatorName}
                              filterName = {this.state.filterName}
                              length={(e) => this.handleShowMore(e)}
                              showtiles = {this.state.showItems}/>
                        </div>
            </div>} />

          <Route path="/upload" exact element={[            
                  <div className="Base">
                        <div className="Menu">
                            <Menu 
                                filterCategory = {this.state.filterCategoryName} 
                                filterVersion= {this.state.filterVersionName} 
                                clickcat={(e) => this.filterCategory(e)}
                                clickVersion={(e) => this.filterVersion(e)}
                                filter={(e) => this.filterSearch(e)}
                                filterName = {this.state.filterName}/>
                                            
                        </div>
                        <div className="Gallery">
                            <Gallery click={this.showInfoTile} 
                              filterCategory = {this.state.filterCategory} 
                              filterVersion= {this.state.filterVersion}     
                              filterCategoryName = {this.state.filterCategoryName}
                              filterVersionName= {this.state.filterVersionName} 
                              stickfig= {this.state.stickfig}
                              creator = {this.state.creatorName}
                              filterName = {this.state.filterName}
                              length={(e) => this.handleShowMore(e)}
                              showtiles = {this.state.showItems}
                            />
                        </div>
                    </div>, 
            <Upload />]}/>

<Route path="/c=:creatorId/id=:stkId"  exact element={[            
          <div className="Base">
                        <div className="Menu">
                            <Menu 
                                filterCategory = {this.state.filterCategoryName} 
                                filterVersion= {this.state.filterVersionName} 
                                clickcat={(e) => this.filterCategory(e)}
                                clickVersion={(e) => this.filterVersion(e)}
                                filter={(e) => this.filterSearch(e)}
                                filterName = {this.state.filterName}
                                />
                                            
                        </div>
                        <div className="Gallery">
                        <Gallery click={this.showInfoTile} 
                              filterCategory = {this.state.filterCategory} 
                              filterVersion= {this.state.filterVersion}     
                              filterCategoryName = {this.state.filterCategoryName}
                              filterVersionName= {this.state.filterVersionName} 
                              stickfig= {this.state.stickfig}
                              creator = {this.state.creatorName}
                              filterName = {this.state.filterName}
                              length={(e) => this.handleShowMore(e)}
                              showtiles = {this.state.showItems}
                            />
                        </div>
            </div>, 
            <Info data = {this.state.stickfig} creatorclick={this.setCreator}/>]}
            />
          <Route path="/id=:stkId"  exact element={[            
          <div className="Base">
                        <div className="Menu">
                            <Menu 
                                filterCategory = {this.state.filterCategoryName} 
                                filterVersion= {this.state.filterVersionName} 
                                clickcat={(e) => this.filterCategory(e)}
                                clickVersion={(e) => this.filterVersion(e)}
                                filter={(e) => this.filterSearch(e)}
                                filterName = {this.state.filterName}
                                />
                                            
                        </div>
                        <div className="Gallery">
                        <Gallery click={this.showInfoTile} 
                              filterCategory = {this.state.filterCategory} 
                              filterVersion= {this.state.filterVersion}     
                              filterCategoryName = {this.state.filterCategoryName}
                              filterVersionName= {this.state.filterVersionName} 
                              stickfig= {this.state.stickfig}
                              creator = {this.state.creatorName}
                              filterName = {this.state.filterName}
                              length={(e) => this.handleShowMore(e)}
                              showtiles = {this.state.showItems}
                            />
                        </div>
            </div>, 
            <Info data = {this.state.stickfig} creatorclick={this.setCreator}/>]}
            />
          <Route path="/c=:creatorId"  exact element={[            
          <div className="Base">
                        <div className="Menu">
                            <Menu 
                                filterCategory = {this.state.filterCategoryName} 
                                filterVersion= {this.state.filterVersionName} 
                                clickcat={(e) => this.filterCategory(e)}
                                clickVersion={(e) => this.filterVersion(e)}
                                filter={(e) => this.filterSearch(e)}
                                filterName = {this.state.filterName}/>
                                            
                        </div>
                        <div className="Gallery">
                        <Gallery click={this.showInfoTile} 
                              filterCategory = {this.state.filterCategory} 
                              filterVersion= {this.state.filterVersion}     
                              filterCategoryName = {this.state.filterCategoryName}
                              filterVersionName= {this.state.filterVersionName} 
                              stickfig= {this.state.stickfig}
                              creator = {this.state.creatorName}
                              filterName = {this.state.filterName}
                              length={(e) => this.handleShowMore(e)}
                              showtiles = {this.state.showItems}
                            />
        
                        </div>
            </div>]}
            />
        </Routes>




      </div>
    );
  }

}

export default App;
